export const HELP_CENTER_URL = 'https://community.xing.com/de/s/';

export const PROMOTE_PAGE_URL = (pageGlobalId: string) =>
  `/xam/aac/?entity_urn=${pageGlobalId}&asset_urn=${pageGlobalId}`;
